import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function Navigation() {
  const scrollToContact = () => {
    const footerForm = document.getElementById('footer-form');
    if (footerForm) {
      footerForm.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.3
  }} className="sticky top-0 z-50 bg-[#0A2540]/95 backdrop-blur-md border-b border-white/10" data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <div className="flex items-center justify-between h-20 md:h-24" data-id="element-120">
          {/* Logo */}
          <div className="flex items-center" data-id="element-121">
            <a href="#" className="flex items-center group" data-id="element-122">
              <img src="https://cdn.magicpatterns.com/uploads/m9sqFFb3nhqtLypfuq3qEr/Dealers-Choice-Solutions-Logo-(Dark-Blue-BG).png" alt="DealersChoice Solutions" className="h-12 md:h-16 w-auto transition-opacity group-hover:opacity-80" data-id="element-123" />
            </a>
          </div>

          {/* Contact Button */}
          <Button variant="primary" size="md" onClick={scrollToContact} className="shadow-lg" data-id="element-124">
            Book A Free Strategy Call
          </Button>
        </div>
      </div>
    </motion.nav>;
}